import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';  // location情報を取得するフック
import ModelViewer from "../ModelViewer";
import ToHomeButton from "../buttons/ToHomeButton";
import ModelSelecter from "../buttons/ModelSelecter";

function Demo1() {
  const location = useLocation();
  const errorScore = location.state?.errorScore;  // 渡されたerrorScoreを取得
  const defaultGlbPath = errorScore ? `model${errorScore}` : "model1";
  const [errorGlbPath, setErrorGlbPath] = useState(defaultGlbPath);
  const [motifGlbPath, setMotifGlbPath] = useState(() => (defaultGlbPath && defaultGlbPath.startsWith("cube") ? "cube" : "model"));

  useEffect(() => {
    if (errorGlbPath && errorGlbPath.startsWith("cube")) {
      setMotifGlbPath("cube");
    } else {
      setMotifGlbPath("model");
    }
  }, [errorGlbPath]);

  return (
    <div className="page demo1-page">
      <h1 className="heading-hero mb-6">旧手法</h1>

      <div className="w-full flex flex-row gap-4">
        <div className="w-1/2 flex flex-col items-center">
          <h2 className="heading-lg mb-2">モチーフ</h2>
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={motifGlbPath}
            imagePath={`./drawing/${motifGlbPath}.png`}
            caption="左"
            canvasId="leftModelCanvas"
          />
        </div>

        <div className="w-1/2 flex flex-col items-center">
          <h2 className="heading-lg mb-2">誤り</h2>
          <h3 className="text-subtitle mb-1">デッサン</h3>
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={errorGlbPath}
            imagePath={`./drawing/${errorGlbPath}.png`}
            caption="右"
            canvasId="rightModelCanvas"
          />
        </div>
      </div>

      <div className="row-center mt-8">
        <ToHomeButton buttonText="Home画面に戻る" />
        <ModelSelecter
          errorGlbPath={errorGlbPath}
          setErrorGlbPath={setErrorGlbPath}
        />
      </div>
    </div>
  );
}

export default Demo1;
